export const AuthorityUserMenu = [
  {
    title: "Dashboard",
    url: "/authority/dashboard",
    icon: "pi pi-th-large"
  },
  {
    title: "Notifications",
    url: "/notification",
    icon: "pi pi-bell"
  },
  {
    title: "Cases List",
    url: "/authority/case/list",
    icon: "pi pi-home"
  }
];
